import React from 'react';
import styled from 'styled-components';
import { TextField } from '@mui/material';
import { useIntl } from 'react-intl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ButtonLinkView from '../../generic/Button/ButtonLinkView';

const Root = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

const InputData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  @media (min-width: 1024px) {
    width: ${(props) => (props.width ? props.width : 'inherit')};
  }
`;

const InputGroup = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
`;

const StyledTextfield = styled(TextField)`
  width: 100%;
  @media (min-width: 1024px) {
    width: ${(props) => (props.width ? props.width : 'inherit')};
  }
`;

const CardsBandCardsBottomArrows = ({ data, setData, buttonLink }) => {
  const intl = useIntl();

  const onChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleChangeCheck = (e) => {
    const { name, checked } = e.target;
    setData({
      ...data,
      [name]: checked,
    });
  };

  return (
    <Root>
      <InputData>
        <StyledTextfield
          id="title"
          name="title"
          onChange={onChange}
          value={data?.title}
          label={intl.formatMessage({ id: 'title' })}
          variant="outlined"
          width="100%"
          margin="normal"
          size="small"
          required
        />
      </InputData>
      <FormControlLabel
        control={
          <Checkbox
            name="autoheight"
            checked={data?.autoheight}
            onChange={handleChangeCheck}
            inputProps={{ 'aria-label': 'controlled invert' }}
          />
        }
        label={intl.formatMessage({ id: 'autoheight' })}
      />
      <ButtonLinkView buttonLink={buttonLink} />
    </Root>
  );
};

export default CardsBandCardsBottomArrows;
